import Vue from "vue";
import LangSelect from "./views/components/land-select/LangSelect.vue";
import BusinessSelect from "./views/components/business-select/BusinessSelect.vue";
import HelpSidebar from "./views/components/help-sidebar/HelpSidebar";
import LiveAgent from "./views/components/liveagent/LiveAgent";

Vue.component(LangSelect.name, LangSelect);
Vue.component(BusinessSelect.name, BusinessSelect);
Vue.component(HelpSidebar.name, HelpSidebar);



// WEBPACK FOOTER //
// ./src/globalComponents.js